import { httpClientPrivate } from '@/libs/httpClient'
import { CrashDetectionCase } from '../types'
import config from '@/config'
import { useQuery } from '@tanstack/react-query'

const fetchCrashDetectionDetail = async (id: string): Promise<CrashDetectionCase> => {
  const { data } = await httpClientPrivate.get<CrashDetectionCase>(
    `${config.restUrl}/v1/backoffice/crash-detection/${id}`,
  )
  return data
}

const useCrashDetectionDetail = (id: string, enabled = true) => {
  const queryKey = ['useCrashDetectionDetail', id]
  const queryFn = async () => fetchCrashDetectionDetail(id)
  const queryResult = useQuery({ queryKey, queryFn, enabled: !!id && enabled })

  return { ...queryResult }
}

export { fetchCrashDetectionDetail, useCrashDetectionDetail }
